import React, { useEffect, useState } from "react";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import Swal from "sweetalert2";
import { Spin } from "antd";

const AddLeaveType = () => {
  const [lvtype, setLvtype] = useState("");
  const [lvcode, setLvcode] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setloading(true);
    if (tokenData && superIdData) {
      if (!lvtype || !lvcode) {
        Swal.fire(
          "Warning",
          "Please fill both Name and Abbreviation",
          "warning"
        );
        return;
      }

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/createLeaveTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify({
              lvtype,
              lvcode,
            }),
          }
        );

        const data = await response.json();

        if (data.status) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Leave Type created successfully!",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error", data.Message || "Something went wrong!", "error");
        }
      } catch (error) {
        console.error("Error creating leave type:", error);
        Swal.fire(
          "Error",
          "Error occurred while creating leave type.",
          "error"
        );
        setloading(false);
      } finally {
        setloading(false);
      }
    }
  };

  const handlecancel = () => {
    setLvcode("");
    setLvtype("");
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddLeaveType");

    const handleOffcanvasClose = () => {
      handlecancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose
        );
      }
    };
  }, []);

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightAddLeaveType"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "20%", maxWidth: "20%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Leave Type</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr className="p-0 m-0" />
        <div className="offcanvas-body">
          <form onSubmit={handleSave}>
            <div className="content">
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Leave Type"
                    value={lvtype}
                    onChange={(e) => setLvtype(e.target.value)}
                    required
                  />
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">
                    <span className="text-danger ms-1">*</span>Abbreviation
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Abbreviation"
                    value={lvcode}
                    onChange={(e) => setLvcode(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="row justify-content-end">
                <div className="col-auto">
                  <button
                    type="button"
                    className="btn btn-secondary mt-3"
                    data-bs-dismiss="offcanvas"
                    onClick={handlecancel}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-auto">
                  <button
                    type="submit"
                    className="btn btn-primary mt-3"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLeaveType;
